import { render, staticRenderFns } from "./groupLessons.vue?vue&type=template&id=1695a85d&scoped=true&lang=pug&"
import script from "./groupLessons.vue?vue&type=script&lang=js&"
export * from "./groupLessons.vue?vue&type=script&lang=js&"
import style0 from "./groupLessons.vue?vue&type=style&index=0&id=1695a85d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1695a85d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
